/**
 * Énumérations partagées front/API. Le SQL porte les mêmes valeurs en contrainte
 * `check` (db/local/10_schema.sql) : ajouter une valeur ici sans la migration,
 * c'est une écriture refusée par la base.
 */
/**
 * Rôles de compte (CDC §3.1). Cumulables : un manager est aussi collaborateur
 * — il déclare ses propres déplacements — et un administrateur peut être RH.
 */
export const ROLES = ['collaborateur', 'manager', 'rh', 'admin'];
export const ROLE_LABELS = {
    collaborateur: 'Collaborateur',
    manager: 'Manager',
    rh: 'RH / Paie',
    admin: 'Administrateur',
};
export function isRole(v) {
    return typeof v === 'string' && ROLES.includes(v);
}
/**
 * Cycle de vie d'une déclaration (CDC §6).
 *
 *   brouillon ──soumettre──▶ a_valider ──manager valide──▶ validee_manager ──RH valide──▶ validee ──export──▶ exportee
 *                   ▲             │                              │
 *                   │             ├─ renvoyer (commentaire) ─────┤──▶ a_corriger ──soumettre──▶ a_valider
 *                   │             └─ refuser  (commentaire) ─────┘──▶ refusee (définitif)
 *
 * Quand la validation RH est désactivée (réglage `validation_rh_active`), la
 * validation manager mène directement à `validee`.
 */
export const STATUTS = [
    'brouillon',
    'a_valider',
    'a_corriger',
    'validee_manager',
    'validee',
    'refusee',
    'exportee',
];
export const STATUT_LABELS = {
    brouillon: 'Brouillon',
    a_valider: 'À valider',
    a_corriger: 'À corriger',
    validee_manager: 'Validée manager — attente RH',
    validee: 'Validée',
    refusee: 'Refusée',
    exportee: 'Exportée en paie',
};
/** Variante de badge altoneo-charting associée à chaque statut. */
export const STATUT_BADGE = {
    brouillon: 'draft',
    a_valider: 'pending',
    a_corriger: 'warning',
    validee_manager: 'sent',
    validee: 'success',
    refusee: 'error',
    exportee: 'completed',
};
/** Statuts « en cours » du point de vue du collaborateur (tableau de bord §8.1). */
export const STATUTS_EN_COURS = ['brouillon', 'a_valider', 'a_corriger', 'validee_manager'];
/** Statuts qui ouvrent droit au paiement. */
export const STATUTS_VALIDES = ['validee', 'exportee'];
/** Gestes de validation (CDC §6.2 / §6.3). */
export const DECISIONS = ['valider', 'refuser', 'renvoyer', 'corriger'];
export const DECISION_LABELS = {
    valider: 'Valider',
    refuser: 'Refuser',
    renvoyer: 'Renvoyer pour correction',
    corriger: 'Corriger et valider',
};
export const NIVEAUX = ['manager', 'rh'];
export const PERIODE_STATUTS = ['ouverte', 'cloturee'];
/** Origine de la distance saisie (CDC §5.2 « calcul automatique… possibilité de correction »). */
export const DISTANCE_SOURCES = ['api', 'manuelle'];
export const EXPORT_FORMATS = ['xlsx', 'csv'];
/** Axes du reporting (CDC §9.2). */
export const REPORTING_AXES = ['salarie', 'manager', 'societe_site', 'periode'];
export const REPORTING_AXE_LABELS = {
    salarie: 'Par salarié (matricule)',
    manager: 'Par manager',
    societe_site: 'Par société / site',
    periode: 'Par période',
};
/** Journaux consultables par l'administrateur (CDC §10). */
export const JOURNAUX = ['modifications', 'connexions', 'validations'];
//# sourceMappingURL=enums.js.map